import { Suspense } from 'react';
import { Canvas } from '@react-three/fiber';
import { Scene, SceneProps } from './Scene';

type Props = SceneProps & { active?: boolean };

export const HeroThreeAnimation = (props: Props) => {
    const { active, ...rest } = props;

    return (
        <Suspense fallback={null}>
            <Canvas id="home-hero-3d" flat eventSource={window.document.documentElement}>
                <Scene visible={active} {...rest} />
            </Canvas>
        </Suspense>
    );
};
